var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.globals)?_c('a',{attrs:{"rel":"noreferrer","target":"_blank","href":("https://www.instagram.com/" + (_vm.globals.instagram.handle) + "/")},domProps:{"textContent":_vm._s(("@" + (_vm.globals.instagram.handle)))}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }